export default "__VITE_ASSET__BDmvhJbZ__"